{
  "book": {
    "brand": "Smart Word Labs",
    "breadcrumb": "احجز تقييمًا مجانيًا",
    "errors": {
      "generic": "تعذّر حجز تقييمك"
    },
    "success": {
      "title": "تم حجز التقييم!",
      "body": "تحقق من بريدك الإلكتروني للحصول على التأكيد وتفاصيل تسجيل الدخول. لقد أرسلنا رابط تسجيل دخول آمنًا إلى",
      "bodyEnd": "حتى تتمكن من الوصول إلى بوابة أولياء الأمور الخاصة بك دون كلمة مرور.",
      "backHome": "العودة إلى الصفحة الرئيسية"
    },
    "form": {
      "title": "احجز تقييمك المجاني",
      "subtitle": "يستغرق أقل من دقيقة. لا حاجة لحساب أو تفاصيل دفع — سنقوم بإعداد بوابة أولياء الأمور نيابة عنك.",
      "parentName": "اسم ولي الأمر",
      "parentEmail": "البريد الإلكتروني لولي الأمر",
      "childName": "اسم الطفل",
      "childAge": "عمر الطفل",
      "date": "التاريخ المفضل",
      "time": "الوقت المفضل",
      "booking": "جارٍ الحجز…",
      "submit": "احجز تقييمًا مجانيًا",
      "alreadyEnrolled": "مسجّل بالفعل؟",
      "parentSignIn": "تسجيل دخول ولي الأمر",
      "localTimeNote": "الأوقات بتوقيت منطقتك"
    }
  },
  "checkout": {
    "title": "الدفع الآمن",
    "summary": "{{name}} — {{monthly}}$ شهريًا، {{lessons}}. يمكن الإلغاء في أي وقت.",
    "couldNotStart": "تعذّر بدء عملية الدفع",
    "choosePlan": {
      "before": "اختر خطة من",
      "link": "صفحة الأسعار",
      "after": "للمتابعة."
    },
    "summaryOneTime": "{{name}} — {{monthly}} دولار لمرة واحدة، {{lessons}}."
  },
  "contact": {
    "breadcrumb": "تواصل معنا",
    "title": "تواصل معنا",
    "subtitle": "استخدم النموذج أدناه وسنعاود التواصل معك شخصيًا خلال يوم عمل واحد.",
    "eyebrow": "تحدث إلينا",
    "heading": "أسئلة حول لغة طفلك الإنجليزية؟",
    "description": "أرسل رسالة وستقوم الأستاذة سلمى بالرد عليك شخصيًا. شاركي رقم الواتساب الخاص بك إذا كنت تفضلين رسالة صوتية سريعة أو مكالمة بدلاً من البريد الإلكتروني.",
    "bullets": {
      "email": "نرد عبر البريد الإلكتروني خلال يوم عمل واحد (الاثنين - السبت).",
      "whatsapp": "تفضل الواتساب؟ أضف رقمك وسنراسلك هناك."
    },
    "form": {
      "name": "اسم ولي الأمر",
      "email": "البريد الإلكتروني",
      "whatsapp": "رقم الواتساب (اختياري)",
      "dialCodeAria": "رمز الاتصال الدولي",
      "whatsappPlaceholder": "300 1234567",
      "childAge": "عمر الطفل (اختياري)",
      "childAgePlaceholder": "مثال: 7",
      "subject": "الموضوع (اختياري)",
      "subjectPlaceholder": "مواعيد الحصص، الأسعار، التقييم…",
      "message": "الرسالة",
      "sending": "جارٍ الإرسال…",
      "pleaseWait": "الرجاء الانتظار {{seconds}} ثانية…",
      "send": "إرسال الرسالة",
      "sentTitle": "تم استلام الرسالة",
      "sentBody": "شكرًا لك — لدينا بياناتك وسنتواصل معك قريبًا.",
      "sendAnother": "إرسال رسالة أخرى",
      "privacyBefore": "نستخدم بياناتك فقط للرد على هذا الاستفسار. اطّلع على",
      "privacyLink": "سياسة الخصوصية",
      "success": "تم إرسال الرسالة — سنرد خلال يوم عمل واحد.",
      "validation": {
        "nameRequired": "يرجى إدخال اسمك",
        "emailInvalid": "يرجى إدخال بريد إلكتروني صحيح",
        "whatsappTooLong": "رقم الواتساب طويل جدًا",
        "whatsappFormat": "استخدم أرقامًا ومسافات و+ أو - فقط",
        "messageTooShort": "يرجى إخبارنا بالمزيد"
      },
      "errors": {
        "tooFast": "كان ذلك سريعًا! يرجى الانتظار لحظة والمحاولة مرة أخرى.",
        "checkForm": "يرجى التحقق من النموذج",
        "captcha": "لم نتمكن من التحقق من هذا الإرسال. يرجى المحاولة مرة أخرى.",
        "sendFailed": "لم نتمكن من إرسال رسالتك. يرجى المحاولة مرة أخرى."
      }
    }
  },
  "howItWorks": {
    "breadcrumb": "كيف تعمل",
    "hero": {
      "title": "كيف تعمل دروسنا الإنجليزية عبر الإنترنت",
      "subtitle": "مجموعات صغيرة. ثقة كبيرة في التحدث. يتم تقييم كل طفل، وتصنيفه، ومتابعته وفق معايير CEFR، ثم تدريسه مباشرة ضمن مجموعة لا تتجاوز خمسة أطفال."
    },
    "pillars": {
      "title": "مبادئنا التعليمية الثلاثة"
    },
    "steps": {
      "title": "من الاستفسار إلى أول درس"
    },
    "cta": {
      "book": "احجز تقييمًا مجانيًا",
      "browsePrograms": "تصفح البرامج حسب العمر",
      "seePricing": "شاهد الأسعار"
    }
  },
  "pricing": {
    "breadcrumb": "الأسعار",
    "compareLink": "غير متأكد أي مستوى؟ قارن بين البرامج"
  },
  "paymentBanner": {
    "notConfigured": "لم يتم تهيئة الدفع الفعلي بعد. أكمل عملية تفعيل الدفع لقبول المدفوعات الحقيقية.",
    "testMode": "جميع المدفوعات التي تتم في المعاينة هي في وضع الاختبار.",
    "testModeLink": "عرض وثائق وضع اختبار الدفع",
    "notReady": "المدفوعات الفعلية ليست جاهزة تمامًا بعد: {{failures}}. جارٍ التحقق مرة أخرى تلقائيًا."
  },
  "faq": {
    "title": "أسئلة يطرحها أولياء الأمور",
    "subtitle": "التقييم المجاني، التقنية، الجدولة، المدفوعات، التصنيف والاسترداد — تمت الإجابة عليها بالكامل.",
    "items": [
      {
        "q": "هل التقييم المجاني مجاني فعلاً، وماذا يحدث فيه؟",
        "a": "نعم — الجلسة الأولى هي تقييم مجاني بالكامل مدته 20-30 دقيقة مع الأستاذة سلمى، دون الحاجة لبيانات بطاقة ائتمانية. يتحدث طفلك ويقرأ ويلعب مهمة تحدث قصيرة بينما تقيس مستواه وفق معايير CEFR. خلال يوم عمل واحد ستحصلون على خطة تعلم مكتوبة ومجموعة موصى بها. لا يوجد أي التزام بالتسجيل بعد ذلك."
      },
      {
        "q": "ما هي المعدات وسرعة الإنترنت التي نحتاجها؟",
        "a": "يكفي جهاز كمبيوتر محمول أو مكتبي أو جهاز لوحي مزود بكاميرا ويب واتصال ثابت بحوالي 5 ميجابت في الثانية — تُقام الدروس في المتصفح عبر زووم، لذا لا حاجة لتثبيت أي شيء آخر. سماعات الرأس المزودة بميكروفون تُحدث فرقًا كبيرًا للأطفال الصغار، والمكان الهادئ جيد الإضاءة يساعدهم على التركيز. تعمل الهواتف عند الضرورة، لكن الشاشة صغيرة جدًا لمهام القراءة المشتركة."
      },
      {
        "q": "كيف نعيد جدولة أو نلغي درسًا؟",
        "a": "أعد الجدولة من بوابة أولياء الأمور قبل الدرس بـ 12 ساعة على الأقل. تتضمن كل خطة رصيدًا لإعادة الجدولة (2 في Starter، و4 في Intensive، وغير محدود في Private). بعد ذلك سنحاول وضع طفلك في مجموعة أخرى بنفس المستوى في نفس الأسبوع دون أي تكلفة إضافية، وإذا لم يتوفر شيء مناسب يرسل معلم طفلك مهمة تعويضية مسجلة ويغطي الفجوة في الدرس التالي."
      },
      {
        "q": "ما هي طرق الدفع التي تقبلونها، وهل هي آمنة؟",
        "a": "تُفوتر الخطط شهريًا بالدولار الأمريكي عبر Stripe، الذي يقبل Visa وMastercard وAmerican Express وApple Pay وGoogle Pay ومعظم شبكات البطاقات المحلية. نحن لا نرى أو نخزن رقم بطاقتك أبدًا — كل شيء يتم التعامل معه عبر صفحة الدفع المتوافقة مع معايير PCI الخاصة بـ Stripe. يمكنك تحديث بطاقتك أو الإلغاء في أي وقت من بوابة أولياء الأمور، والإلغاء يوقف ببساطة التجديد التالي."
      },
      {
        "q": "كيف يُوضع طفلي في الفئة العمرية والمستوى المناسبين؟",
        "a": "يتم التصنيف بحسب مستوى CEFR أولاً والفئة العمرية ثانيًا، لذلك لا يُبطئ طفل بعمر ست سنوات واثق أبدًا ولا يُثقل طفل بعمر تسع سنوات هادئ أبدًا. يمنحنا التقييم المجاني المستوى؛ ثم تحدد الفئات العمرية (4-6 مستكشفو الصوتيات المبكرة، 7-9 بناة القراءة والكتابة، 10-12 متحدثون واثقون) الوتيرة والمواد ومدة الدرس. إذا تجاوز الطفل مستوى مجموعته في منتصف الفصل، ننقله إلى الأعلى دون أي رسوم إضافية."
      },
      {
        "q": "ما هي سياسة الاسترداد الخاصة بكم؟",
        "a": "إذا لم تكن راضيًا بعد الشهر الأول المدفوع لطفلك، راسلنا عبر البريد الإلكتروني خلال 14 يومًا من ذلك الرسم الأول وسنقوم برده بالكامل. بعد ذلك، يوقف الإلغاء التجديد التالي وتحتفظ بكل درس مدفوع بالفعل حتى نهاية شهر الفوترة — لا نفرض رسوم إلغاء. التفاصيل الكاملة موجودة في سياسة الاسترداد الخاصة بنا."
      },
      {
        "q": "كيف سأعرف أن طفلي يتقدّم؟",
        "a": "يُقيَّم كل طفل وفق مستويات CEFR في البداية. تتلقى تقريرًا مكتوبًا عن التقدّم كل شهر، وإذا كان التقدّم أبطأ من المخطط، تعدّل Ms. Salma خطة التعلّم وتناقشها معك."
      }
    ]
  },
  "faculty": {
    "title": "تعرّف على معلمتك",
    "subtitle": "يتم تدريس كل درس من قبل الأستاذة سلمى، الحاصلة على شهادة CELTA ومتخصصة في تعليم اللغة الإنجليزية للأطفال، وتعمل وفق منهجنا المتوافق مع معايير CEFR.",
    "teacher": {
      "name": "الأستاذة سلمى",
      "credential": "حاصلة على شهادة CELTA (كامبريدج للغة الإنجليزية) · بكالوريوس في اللغة الإنجليزية وعلم النفس التطبيقي",
      "experience": "أكثر من 10 سنوات في تدريس اللغة الإنجليزية، من المرحلة الابتدائية إلى البالغين، عبر كندا والشرق الأوسط",
      "detail": "محو الأمية المبكر والصوتيات وفق المنهج البريطاني، دروس متوافقة مع CEFR، تدريب على IELTS والمقابلات.",
      "quote": "تعلق الصوتيات في الذهن عندما تبدو وكأنها لعب، لا تدريب.",
      "photoAlt": "الأستاذة سلمى، معلمة لغة إنجليزية حاصلة على شهادة CELTA في Smart Word Labs"
    }
  },
  "testimonials": {
    "title": "ماذا يقول أولياء الأمور عن دروسنا الإنجليزية عبر الإنترنت",
    "ratingSummary": "4.9/5 من أكثر من 1200 تقييم موثّق من أولياء الأمور",
    "starsAria": "{{rating}} من 5 نجوم",
    "prevAria": "التقييمات السابقة",
    "nextAria": "التقييمات التالية",
    "pageAria": "عرض صفحة التقييمات {{page}}",
    "reviews": [
      {
        "quote": "انتقل عارف من إجابات بكلمة واحدة إلى إخبارنا بقصص كاملة عن درسه. مجموعة من أربعة أطفال تعني أنه مضطر فعلاً للتحدث — وهذا غيّر كل شيء.",
        "name": "سناء م.",
        "childAge": "ولية أمر طفل عمره 6 سنوات",
        "location": "دبي، الإمارات العربية المتحدة",
        "rating": 5
      },
      {
        "quote": "تقرير CEFR الشهري هو أول شيء أحصل عليه يُظهر بالفعل تقدمًا وليس مجرد 'إنها بخير'. يستحق كل قرش.",
        "name": "راشيل ت.",
        "childAge": "والدة طفلة عمرها 9 سنوات",
        "location": "لندن، المملكة المتحدة",
        "rating": 5
      },
      {
        "quote": "طفلاي على نفس الحساب ويمكنني رؤية دروسهما جنبًا إلى جنب. إعادة الجدولة تستغرق عشر ثوانٍ.",
        "name": "إبراهيم ك.",
        "childAge": "والد لطفلين، أعمارهما 7 و11 سنة",
        "location": "كراتشي، باكستان",
        "rating": 5
      },
      {
        "quote": "حوّل برنامج بناة القراءة والكتابة القراءة من صراع إلى شيء تطلبه بنفسها. قفزت كتابتها في المدرسة مستوى كاملاً في فصل دراسي واحد.",
        "name": "بريا ن.",
        "childAge": "والدة طفلة عمرها 8 سنوات",
        "location": "سنغافورة",
        "rating": 5
      },
      {
        "quote": "برنامج متحدثون واثقون هو بالضبط ما احتاجه ابننا قبل المدرسة الثانوية — أصبح الآن يعرض حجته على طاولة العشاء دون تردد.",
        "name": "ماركو ب.",
        "childAge": "والد طفل عمره 11 سنة",
        "location": "ميلانو، إيطاليا",
        "rating": 5
      },
      {
        "quote": "دروس الصوتيات المبكرة مدتها 30 دقيقة فقط، وهي مثالية لمدى انتباه طفل عمره خمس سنوات. أصبح الآن يتهجى الكلمات في كل مكان نذهب إليه.",
        "name": "هانا ل.",
        "childAge": "والدة طفل عمره 5 سنوات",
        "location": "مانشستر، المملكة المتحدة",
        "rating": 5
      },
      {
        "quote": "استخدمنا برنامج التحضير للمقابلات قبل تقييمات القبول. دخلت ابنتنا وهي مسترخية تمامًا وحصلت على مكانها المفضل الأول.",
        "name": "إيلينا ف.",
        "childAge": "والدة طفلة عمرها 10 سنوات",
        "location": "مدريد، إسبانيا",
        "rating": 5
      },
      {
        "quote": "لاحظت الأستاذة سلمى خلال درسين فقط أن ابني كان يخمّن بدلاً من فك رموز الكلمات. لم يلاحظ ذلك أحد في المدرسة خلال عام كامل.",
        "name": "يوسف أ.",
        "childAge": "والد طفل عمره 7 سنوات",
        "location": "الدوحة، قطر",
        "rating": 5
      },
      {
        "quote": "كان التقييم المجاني وحده أكثر فائدة من التجارب المدفوعة التي جربناها في أماكن أخرى. سجّلنا في نفس الأسبوع ولم ننظر إلى الوراء منذ ذلك الحين.",
        "name": "كلير د.",
        "childAge": "والدة طفلة عمرها 9 سنوات",
        "location": "تورونتو، كندا",
        "rating": 4
      }
    ]
  },
  "placementQuiz": {
    "eyebrow": "تصنيف خلال 30 ثانية",
    "title": "اعثر على المجموعة المناسبة في 30 ثانية",
    "subtitle": "ثلاثة أسئلة سريعة وسنوجهك إلى البرنامج المناسب لطفلك.",
    "stepOf": "الخطوة {{current}} من {{total}}",
    "back": "← رجوع",
    "recommended": "البرنامج الموصى به",
    "bookCta": "احجز تقييمك المجاني",
    "seeFullProgramme": "شاهد البرنامج الكامل",
    "startAgain": "ابدأ من جديد",
    "reasons": {
      "new": "سنبدأ بالأصوات والإجابات الشفهية القصيرة حتى يبني طفلك الثقة قبل زيادة الوتيرة.",
      "confident": "طفلك مستعد لجولات تحدث أطول، لذا تُركّز الدروس على البنية والمفردات والحجج.",
      "default": "توازن الدروس بين التمرين الموجّه والكثير من وقت التحدث المستقل."
    },
    "steps": [
      {
        "key": "age",
        "title": "كم عمر طفلك؟",
        "options": [
          {
            "value": "4-6",
            "label": "4-6 سنوات"
          },
          {
            "value": "7-9",
            "label": "7-9 سنوات"
          },
          {
            "value": "10-12",
            "label": "10-12 سنة"
          }
        ]
      },
      {
        "key": "goal",
        "title": "ما الأهم الآن؟",
        "options": [
          {
            "value": "phonics",
            "label": "القراءة والصوتيات"
          },
          {
            "value": "writing",
            "label": "الكتابة والواجبات المدرسية"
          },
          {
            "value": "speaking",
            "label": "الثقة في التحدث"
          },
          {
            "value": "exams",
            "label": "الاختبارات والمقابلات"
          }
        ]
      },
      {
        "key": "comfort",
        "title": "ما مدى راحة طفلك في التحدث بالإنجليزية؟",
        "options": [
          {
            "value": "new",
            "label": "بدأ للتو"
          },
          {
            "value": "some",
            "label": "بضع جمل"
          },
          {
            "value": "confident",
            "label": "يتحدث بحرية إلى حد ما"
          }
        ]
      }
    ]
  },
  "cohortTimeConverter": {
    "intro": "تُدرّس السيدة سلمى من تورونتو. مواعيد الدروس بتوقيت منطقتك:",
    "timezoneLabel": "منطقتك الزمنية",
    "timezonePlaceholder": "اختر منطقتك الزمنية",
    "footnote": "الأوقات معروضة بتوقيتك المحلي. يتم تأكيد موعدك بالضبط خلال التقييم المجاني."
  }
}
